export default __webpack_public_path__ + "static/media/mixkit-gaming-lock-2848.47150c61.wav";